<template>
	<div class="game-filter" v-bind:class="'game-filter--' + layout">
		<div class="game-filter__centraliser" v-bind:class="{
			'page-container': centralise
		}">

			<div class="grid grid--middle grid--g0" v-bind:class="{
				'grid--s0 grid--auto grid--nowrap': layout === 'horizontal',
				'grid--s24': layout === 'vertical',
			}">		<!-- <attr class="grid--s0 grid--auto grid--nowrap grid--s24" /> -->

				<div v-if="includeRegions" class="game-filter__group game-filter__group--regions clickable grid__item " v-bind:class="{
					'o--2n' : layout === 'vertical',
					'game-filter__group--regions--active' : showRegionSelector,
				}" @click.stop="showRegionSelector = !showRegionSelector; trackEvent([
					'game-region-filter-clicked',
					showRegionSelector ? 'opened' : 'closed',
					$root.$data.user ? $root.$data.user.trackName : null,
					0,
					false
				])">		<!-- <attr class="o--2n" /> -->

					<div class="game-filter__icon-wrap fc-pal--blue" :class="{
						'hide' : layout == 'vertical'
						// <attr class='hide' />
					}">
						<span class="fonticon fonticon--globe game-filter__icon fs--21c mb--16c">
							<span class="game-filter__badge">{{filters.regions.length}}</span>
						</span>
						<div class="game-filter__icon-text">Filter by Region</div>
					</div>

					<div v-if="layout === 'vertical'" class="game-filter__group-title">Filter by region:</div>

					<RegionSelector v-show="showRegionSelector || layout == 'vertical'" class="game-filter__region-selector" v-model="filters.regions" :isMultiSelect="true" :hasSelectedSummary="true" @click.native.stop @input="filterChanged('regions')">
						<template v-slot:footerAction>
							<span class="link link--action" @click="filters.regions = []; filterChanged('regions'); showRegionSelector = false;">View all regions</span>
						</template>
					</RegionSelector>


				</div>
				<div class="game-filter__group grid__item" v-bind:class="{
					'o--3n': layout === 'vertical',
					'grid__item--space': layout == 'horizontal',
				}">		<!-- <attr class="o--3n grid__item--space" /> -->

					<div v-if="layout === 'vertical'" class="game-filter__group-title">Filter</div>

					<div class="grid grid--s0" v-bind:class="{
						'grid--g16 grid--auto grid--nowrap grid--spread-items w--100p': layout === 'horizontal',
					}">		<!-- <attr class="grid--g16 grid--auto grid--nowrap grid--spread-items w--100p" /> -->
						<template v-if="includeSort">
							<template v-if="splitSort">
								<div class="grid__item">
									<radio-field v-model="filterSort" class="game-filter__type game-filter__type--alphabetical" @input="filterChanged('sort-order')">
										<option value="gameName--asc">A-Z</option>
									</radio-field>
								</div>
								<div class="grid__item">
									<radio-field v-model="filterSort" class="game-filter__type game-filter__type--new" @input="filterChanged('sort-order')">
										<option value="regionalReleaseDate--desc">Most <br />Recent</option>
									</radio-field>
								</div>
							</template>
						</template>
						<div class="grid__item">
							<checkbox-field v-model="filters.type" class="game-filter__type game-filter__type--core-games" @input="filterChanged('core-games')">
								<option value="type-core-games">Core <br />Games</option>
							</checkbox-field>
						</div>
						<div class="grid__item">
							<checkbox-field v-model="filters.type" class="game-filter__type game-filter__type--casual-games" @input="filterChanged('casual-games')">
								<option value="type-casual-games">Casual <br />Games</option>
							</checkbox-field>
						</div>
						<div class="grid__item">
							<checkbox-field v-model="filters.type" class="game-filter__type game-filter__type--branded" @input="filterChanged('branded')">
								<option value="type-branded">Branded</option>
							</checkbox-field>
						</div>
						<div class="grid__item">
							<checkbox-field v-model="filters.type" class="game-filter__type game-filter__type--jackpot" @input="filterChanged('jackpot')">
								<option value="type-jackpot">Jackpot</option>
							</checkbox-field>
						</div>
						<div class="grid__item">
							<checkbox-field v-model="filters.topPerformer" class="game-filter__type game-filter__type--top-performer" @input="filterChanged('topPerformer')">
								<option :value="true">Top <br />Performers</option>
							</checkbox-field>
						</div>
					</div>

				</div>
				<div class="game-filter__group game-filter__group--search clickable grid__item " v-bind:class="{
					'o--1n' : layout === 'vertical',
					'game-filter__group--search--active' : showSearch,
				}" @click.stop="showSearch = !showSearch">		<!-- <attr class="o--1n" /> -->

					<div class="game-filter__icon-wrap" :class="{
						'hide' : layout == 'vertical'
						// <attr class='hide' />
					}">
						<span class="fonticon fonticon--search game-filter__icon fs--21c mb--16c"></span>
						<div class="game-filter__icon-text">Search</div>
					</div>

					<div class="game-filter__search" v-show="showSearch || layout == 'vertical'" @click.stop >
						<autocomplete ref="search" placeholder="Search for a game..." :items="autocompleteData" @input="gameSearched"></autocomplete>
					</div>

				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { cloneDeep, map } from 'lodash';
import { mapGetters } from 'vuex';

import CheckboxField from '../atoms/CheckboxField';
import RadioField from '../atoms/RadioField';
import RegionSelector from '../atoms/RegionSelector'
import Autocomplete from '../molecules/Autocomplete'

export default {
	name: 'GameFilter',
	components: {
		CheckboxField,
		RadioField,
		RegionSelector,
		Autocomplete
	},
	data () {
		return {
			showRegionSelector: false,
			showSearch: false,
			filterSort: 'regionalReleaseDate--desc',
			filtersDefault: {
				regions: [this.$root.userSelectedRegion.key],
				sort: [
					{'regionalReleaseDate': 'desc'}
				],
				type: [
				],
				topPerformer: [],
				search: null
			},
			filters: null
		}
	},
	props: {
		isVertical: {
			type: Boolean,
			default: true
		},
		centralise: {
			type: Boolean,
			default: true
		},
		includeSort: {
			type: Boolean,
			default: true
		},
		splitSort: {
			type: Boolean,
			default: false
		},
		includeRegions: {
			type: Boolean,
			default: true
		},
		autocompleteData: Array,
	},
	computed: {
		...mapGetters({
			'types': 'app/types',
		}),
		layout: function()
		{
			var self = this;
			return self.isVertical || self.$mq === 'mob' || self.$mq === 'ptab' ? 'vertical' : 'horizontal';
		},
	},
	watch: {
		'$root.userSelectedRegionKey' : function(to, from)
		{
			this.filtersDefault.regions = [this.$root.userSelectedRegion.key];
			this.filters.regions = [this.$root.userSelectedRegion.key];
			this.filterChanged('regions');
		},
		filterSort: function(to, from)
		{
			var split = to.split('--');
			if(split.length == 2)
			{
				var obj = {};
				obj[split[0]] = split[1];
				this.filters.sort = [obj];
			}
		},
	},
	created: function()
	{
		this.$eventBus.$on('window-click', this.closeAllPopups);
		this.filters = cloneDeep(this.filtersDefault);
	},
	beforeDestroy: function()
	{
		this.$eventBus.$off('window-click', this.closeAllPopups);
	},
	methods: {
		closeAllPopups()
		{
			this.showRegionSelector = false;
			this.showSearch = false;
		},
		filterChanged(name)
		{
			var self = this;
			self.emitFilterChanged();
			self.trackEvent([
				'filter-changed',
				name,
				self.$root.$data.user ? self.$root.$data.user.trackName : null,
				0,
				false
			]);
		},
		gameSearched(gameId)
		{
			var self = this;
			self.filters.search = gameId;
			self.emitFilterChanged();

			// If not resetting...
			if(gameId !== null)
			{
				self.trackEvent([
					'filter-changed',
					'game-search',
					self.$root.$data.user ? self.$root.$data.user.trackName : null,
					0,
					false
				]);
			}
		},
		reset()
		{
			var self = this;
			self.filters = cloneDeep(self.filtersDefault);
			self.filters.regions = [this.$root.userSelectedRegion.key];
			self.$refs.search.setResult(self.filters.search);
			self.emitFilterChanged();
		},
		emitFilterChanged()
		{
			this.$nextTick(() => {
				this.$emit('filterChanged', this.filters);
			})
		}
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".game-filter";
	#{$c}
	{
		&--vertical
		{
			// --- Doesn't work for the Asset Manager view -----
			// padding-top: rem(24);
			// padding-bottom: rem(24);
		}

		&__centraliser
		{
			#{$c}--horizontal &
			{
				padding-left: 0;
				padding-right: 0;
			}
		}

		&__group
		{
			position: relative;

			#{$c}--horizontal &
			{
				padding-top: rem(24);
				padding-bottom: rem(24);
				display: flex;
				align-items: center;

				@include media(desk)
				{
					padding-left: rem(48);
					padding-right: rem(48);
				}

				@include media(ltab)
				{
					padding-left: rem(24);
					padding-right: rem(24);
				}
			}

			&--regions,
			&--search
			{
				#{$c}--horizontal &
				{
					margin-right: -1px;

					&--active
					{
						color: palette(blue);
						box-shadow: inset 0 0 0 1px palette(lighter-grey), 0 4px 8px rgba(0,0,0,0.05);

						&:after
						{
							content: '';
							display: block;
							position: absolute;
							height: 5px;
							left: 1px;
							right: 1px;
							top: calc(100% - 10px);
							background-color: palette(white);
							z-index: 100;
						}
					}
				}
			}

			&:not(:first-child):before
			{
				#{$c}--horizontal &
				{
					content: "";
					position: absolute;
					display: block;
					width: 1px;
					height: 100%;
					background-color: palette(lighter-grey);
					top: 0;
					left: 0;
				}
			}

			&-title
			{
				@include extend(heading-font-bold);

				#{$c}--vertical &
				{
					@include extend(h5-size);
					margin-bottom: rem(24);
				}
			}
		}

		&__icon
		{
			position: relative;

			&-wrap
			{
				#{$c}--horizontal &
				{
					font-size: 10px;
					line-height: 1.2;
					text-align: center;
					text-indent: 0;
					padding-left: 0;
				}
			}

			&-text
			{
				@include extend(lato-bold);
				text-transform: uppercase;
			}
		}

		&__badge
		{
			@include extend(badge);
			@include extend(bgc-pal--red);
			@include extend(lato-bold);
			font-size: 10px;
			position: absolute;
			top: 0;
			right: 0;
			transform: translateX(50%) translateY(-50%);
			z-index: 1;
		}

		&__region-selector
		{
			#{$c}--horizontal &
			{
				position: absolute;
				left: 0;
				top: calc(100% - 8px);
				box-shadow: inset 0 0 0 1px palette(lighter-grey), 0 4px 8px rgba(0,0,0,0.05);
				z-index: 99;
			}

			#{$c}--vertical &
			{
				max-width: none;
				width: 100%;
				padding: 0;
			}
		}

		&__type.field--checkbox, 			// <--- Increase specificity
		&__type.field--radio
		{
			#{$c}--horizontal &
			{
				line-height: 0;
			}

			#{$c}--vertical &
			{
				background-color: palette('white');
				padding: 13px 15px;
				border: 1px solid palette('divider');
				border-top-width: 0;
			}

			#{$c}--vertical :first-child > &,
			#{$c}--vertical &#{$c}__type--fast-play
			{
				border-top-left-radius: 4px;
				border-top-right-radius: 4px;
				border-top-width: 1px;
			}

			#{$c}--vertical :last-child > &,
			#{$c}--vertical &#{$c}__type--new
			{
				border-bottom-left-radius: 4px;
				border-bottom-right-radius: 4px;
			}

			#{$c}--vertical &#{$c}__type--fast-play
			{
				margin-top: rem(16);
			}


			.field__sub-label
			{
				#{$c}--vertical &
				{
			    text-indent: -23px;
			    padding-left: 23px;
				}

				#{$c}--horizontal &
				{
					min-width: 100%;
					@include extend(btn);
					@include extend(btn--style--stroke);
					@include extend(btn--style--stroke--light-grey);
					padding-left: rem(24);
					padding-right: rem(24);
					color: palette('grey');
					border-width: 1px;
					text-indent: 0;

					> *
					{
						font-size: 10px;
						line-height: 1.4;
					}

					&:after
					{
						height: 43px;
					}
				}

				&:before
				{
					#{$c}--vertical &
					{
						font-size: 10px;
						width: 16px;
						height: 16px;
						margin-right: 10px;
						border-radius: 0;
					}

					#{$c}--horizontal &
					{
						display: none;
					}
				}

				> *
				{
					@extend .game-filter__icon-text;
					color: palette(font);

					#{$c}--vertical &
					{
						font-size: rem(11);

						br
						{
							display: none;
						}
					}
				}
			}

			.field__element:checked + .field__sub-label
			{
				&:before
				{
					color: palette(blue);
				}

				#{$c}--horizontal &
				{
					border-color: palette('blue');
					color: palette('blue');

					> *
					{
						color: inherit;
					}
				}
			}
		}


		&__type.field--checkbox 			// <--- Increase specificity
		{
			.field__sub-label
			{
				&:before
				{
					#{$c}--vertical &
					{
						font-size: 10px;
						width: 16px;
						height: 16px;
						margin-right: 10px;
						border-radius: 0;
					}
				}
			}
		}
		&__type.field--radio 			// <--- Increase specificity
		{
			.field__sub-label
			{
				&:before
				{
					#{$c}--vertical &
					{
						font-size: 8px;
						width: 20px;
						height: 20px;
						margin-right: 8px;
						border-width: 1px;
						border-radius: 50%;
					}
				}
			}
		}


		&__search
		{
			color: palette(grey);
			background-color: palette(white);
			border-radius: calc(1px * #{var(field-border-radius)});

			#{$c}--horizontal &
			{
				position: absolute;
				width: 472px;
				right: 0;
				top: calc(100% - 8px);
				box-shadow: inset 0 0 0 1px palette(lighter-grey), 0 4px 8px rgba(0,0,0,0.05);
				padding: rem(32);
				z-index: 99;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/organisms/GameFilter.vue